<div *ngIf="content" [innerHTML]="content"></div>
